import React, { FC, useCallback } from "react";
import { useForm } from "react-hook-form";
import { TextField, Card, Flex, Heading } from "@radix-ui/themes";
import { Button } from "@/components/button";
import { useAtlasAuthContext } from "@/contexts/atlas-auth";
import { css } from "@/domains/emotion";
import { toastModule } from "@/modules/toast";
import { useNavigate } from "react-router-dom";
import { atlasRoutes } from "@/app/router/routes";
import memLogomarkImage from "@/assets/images/logomark.svg";

interface FormData {
  email: string;
  password: string;
}

export const LogInEmailPasswordPage: FC = () => {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<FormData>();
  const { authContext } = useAtlasAuthContext();
  const navigate = useNavigate();

  const onSubmit = useCallback(
    async (data: FormData) => {
      try {
        await authContext.authenticateAccountUsingEmailPassword({
          email: data.email,
          password: data.password,
        });

        navigate(atlasRoutes.home({}).path);
      } catch (_error) {
        toastModule.triggerToast({ content: "Failed to login." });
      }
    },
    [authContext, navigate]
  );

  return (
    <Flex align="center" justify="center" height="100%" width="100%">
      <Card className={cardStyles}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flex direction="column" gap="4" align="center">
            <Heading>Atlas</Heading>
            <img className={imageStyles} src={memLogomarkImage} alt="Mem Logo" />
            <TextField.Root
              {...register("email", { required: true })}
              placeholder="Email"
              type="email"
            />
            <TextField.Root
              {...register("password", { required: true })}
              placeholder="Password"
              type="password"
            />
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? "Logging in..." : "Log In"}
            </Button>
            <Button onClick={() => navigate(atlasRoutes.logIn({}).path)}>
              Back to Login Options
            </Button>
          </Flex>
        </form>
      </Card>
    </Flex>
  );
};

const cardStyles = css({
  padding: "32px 80px",
  marginBottom: 80,
});

const imageStyles = css({
  width: 32,
  height: 32,
});
